import { useQuery } from '@tanstack/react-query';
import apiService from '../services/api';
import type { DeliveryPricingResponse } from '../utils/deliveryPricing';

export type DeliveryPricingQueryParams = {
  conversationId?: number;
  locationProviderId?: number;
  foundObjectId?: number;
  categoryId?: number;
  itemType?: string;
};

export function deliveryPricingQueryKey(params?: DeliveryPricingQueryParams) {
  return [
    'delivery-pricing',
    {
      conversationId: params?.conversationId ?? null,
      locationProviderId: params?.locationProviderId ?? null,
      foundObjectId: params?.foundObjectId ?? null,
      categoryId: params?.categoryId ?? null,
      itemType: params?.itemType ?? null,
    },
  ] as const;
}

export function useDeliveryPricing(params?: DeliveryPricingQueryParams) {
  return useQuery<DeliveryPricingResponse>({
    queryKey: deliveryPricingQueryKey(params),
    queryFn: () =>
      apiService.getDeliveryPricing({
        conversationId: params?.conversationId,
        locationProviderId: params?.locationProviderId,
        foundObjectId: params?.foundObjectId,
        categoryId: params?.categoryId,
        itemType: params?.itemType,
      }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
